<template>
  <ValidationObserver>
    <div id="summary">
      <v-form>
        <v-card v-for="item in modelObjects" :key="item.curriculum">
          <v-card-title primary-title class="amber lighten-1">
            <v-layout align-baseline justify-space-between>
              <h3 class="headline pb-2 blue--text text--darken-4"><v-icon color="blue darken-4">explore</v-icon> Souhaits / Profil</h3>
              <SectionsLayout
                :cv_id='cv_id'
                section='persum'
              >
              </SectionsLayout>
            </v-layout>
          </v-card-title>


          <v-card-text>
            <v-form>
              <v-layout row wrap>

                <v-flex xs12 sm6 md6 lg6 xl6 pb-0>
                  <ValidationProvider name="titre du poste recherché" rules="max:72">
                    <v-text-field
                      slot-scope="{
                                  errors,
                                  valid
                                  }"
                      :error-messages="errors"
                      :success="valid"
                      label="Titre du poste recherché:"
                      v-model="item.job_title"
                      v-on:blur="updateModelObject(item.curriculum, item)"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-flex>

                <v-flex xs12 sm6 md6 lg6 xl6 pb-0>
                  <ValidationProvider name="phrase d'accroche" rules="max:128">
                    <v-text-field
                      slot-scope="{
                                  errors,
                                  valid
                                  }"
                      :error-messages="errors"
                      :success="valid"
                      label="Phrase d'accroche:"
                      v-model="item.phrase"
                      v-on:blur="updateModelObject(item.curriculum, item)"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-flex>

                <v-flex xs12>
                  <ValidationProvider name="commentaires" rules="max:1024">
                    <wysiwyg
                      slot-scope="{
                                  errors,
                                  valid
                                  }"
                      :error-messages="errors"
                      :success="valid"
                      label="Développer votre profil, vos points forts et vos attentes:"
                      v-model="item.summary"
                      placeholder="Développer votre profil, vos points forts et vos attentes:"
                      v-on:change="updateModelObject(item.curriculum, item)"
                    >
                    </wysiwyg>
                  </ValidationProvider>
                </v-flex>

              </v-layout>
            </v-form>


          </v-card-text>
        </v-card>
      </v-form>
    </div>
  </ValidationObserver>

</template>



<script>
 import {
   ValidationObserver,
   ValidationProvider,
   withValidation
 } from "vee-validate";
 import { mixin_ajax } from './mixin_ajax_vue.js';
 import session from '../api/session';
 import SectionsLayout from '../components/SectionsLayout';

 // inutile d'importer 'mapaction' ici car
 // elle est hérité du mixin ajax!!!!

 export default {
   mixins: [mixin_ajax],
   props: ['cv_id'],
   components: {
     SectionsLayout,
     ValidationProvider,
     ValidationObserver
   },
   data: function() {
     return {
       api_url: '/api/' + this.cv_id + '/summary/',
       modelObjects: [],
       isLoading: false,
       currentModelObject: {},
       message: null,
       newModelObject: function() {
         return {
           'curriculum': this.cv_id,
         }
       },
     }
   },

   methods: {
     // inutile de déclarer les 'mapactions' ici car
     // elles sont dans le mixin ajax!!!!
     getModelObjects: function() {
       this.isLoading = true;
       session.get(this.api_url)
              .then((response) => {
                // créer s'il n'y a aucun objet
                if (response.data.length == 0) {
                  this.addModelObject();
                }
                this.modelObjects = response.data;
                this.isLoading = false;
                this.loadingAddElem();
                console.log('GET CALLED : ' + this.api_url);
                console.log(response)
              })
              .catch((err) => {
                this.isLoading = false;
                this.loadingAddElem();
                if (err.response) {
                  // The request was made and the server responded with a status code
                  // that falls out of the range of 2xx
                  console.log('======= getModelObjects error in response =======')
                  console.log(err.response.data);
                  console.log(err.response.status);
                  console.log(err.response.headers);
                } else if (err.request) {
                  // The request was made but no response was received
                  // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                  // http.ClientRequest in node.js
                  console.log('======= getModelObjects error in request =======')
                  console.log(err.request);
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.log('======= getModelObjects error in else =======')
                  console.log('Err', err.message);
                }
              })
     },

     updateModelObject: function(id, postedObject) {
       this.isLoading = true;
       this.currentModelObject = postedObject
       console.log("Changement sur l'objet : " + this.currentModelObject.curriculum);
       console.log(this.currentModelObject)
       // gestion de la protection csrf :
       // axios.defaults.xsrfCookieName = 'csrftoken'
       // axios.defaults.xsrfHeaderName = 'X-CSRFToken'
       session.put(`${this.api_url}${this.currentModelObject.curriculum}/`, this.currentModelObject)
              .then((response) => {
                this.isLoading = false;
                this.currentModelObject = response.data;

              })
              .catch((err) => {
                this.isLoading = false;
                if (err.response) {
                  // The request was made and the server responded with a status code
                  // that falls out of the range of 2xx
                  console.log('======= updateModelObject error in response =======')
                  console.log(err.response.data);
                  console.log(err.response.status);
                  console.log(err.response.headers);
                } else if (err.request) {
                  // The request was made but no response was received
                  // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                  // http.ClientRequest in node.js
                  console.log('======= updateModelObject error in request =======')
                  console.log(err.request);
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.log('======= updateModelObject error in else =======')
                  console.log('Err', err.message);
                }
              })
     },
   }

 }
</script>

<style>

</style>
